export const TEAM_OPTIONS = [
  { label: 'TherapEase', value: 'TherapEase' },
  { label: 'RePick', value: 'RePick' },
  { label: 'BariBari', value: 'BariBari' },
  { label: 'Hooking', value: 'Hooking' },
  { label: 'Dansupport', value: 'Dansupport' },
];

export const PART_OPTIONS = [
  { label: 'FRONTEND', value: 'fe' },
  { label: 'BACKEND', value: 'be' },
];
